import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/apiClient";

const TYPES = [
  { v: "", l: "All" },
  { v: "surf_school", l: "Surf schools" },
  { v: "instructor", l: "Instructors" },
  { v: "board_hire", l: "Board hire" },
  { v: "wetsuit_hire", l: "Wetsuit hire" },
  { v: "surf_camp", l: "Surf camps" },
  { v: "surf_accommodation", l: "Accommodation" },
  { v: "surf_shop", l: "Surf shops" },
];

export default function Businesses() {
  const [items, setItems] = useState([]);
  const [type, setType] = useState("");

  useEffect(() => {
    const q = type ? `?business_type=${type}` : "";
    api.get(`/businesses${q}`).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, [type]);

  return (
    <div className="max-w-6xl mx-auto px-5 md:px-8 py-10 md:py-14" data-testid="businesses-page">
      <div className="overline">Directory</div>
      <h1 className="font-display text-3xl md:text-4xl text-teal-900 mt-2">Surf schools & hire</h1>
      <p className="mt-2 text-sm text-muted-foreground max-w-2xl">
        Free listings for surf businesses across our coverage areas. Listing does not affect the
        recommendation score.
      </p>

      <div className="mt-6 flex flex-wrap gap-2" data-testid="business-type-filters">
        {TYPES.map((t) => (
          <button
            key={t.v}
            onClick={() => setType(t.v)}
            data-testid={`biz-filter-${t.v || "all"}`}
            className={`px-3 py-1.5 rounded-full text-xs border ${
              type === t.v
                ? "bg-teal-800 text-white border-teal-800"
                : "bg-white border-border hover:border-teal-800/50"
            }`}
          >
            {t.l}
          </button>
        ))}
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((b) => (
          <Link
            key={b.id}
            to={`/business/${b.id}`}
            data-testid={`biz-card-${b.id}`}
            className="card-soft overflow-hidden hover:-translate-y-0.5 transition-transform block"
          >
            {b.image_url && (
              <div className="h-32 bg-cover bg-center" style={{ backgroundImage: `url(${b.image_url})` }} />
            )}
            <div className="p-5">
              <div className="flex items-center gap-2 flex-wrap mb-1">
                {b.featured && (
                  <span className="text-[10px] uppercase tracking-widest bg-terracotta-500 text-white px-2 py-0.5 rounded-full">Featured</span>
                )}
                {b.verified && (
                  <span className="text-[10px] uppercase tracking-widest bg-teal-800 text-white px-2 py-0.5 rounded-full">Verified</span>
                )}
                <span className="text-[10px] uppercase tracking-widest text-muted-foreground">
                  {b.business_type.replace(/_/g, " ")}
                </span>
              </div>
              <div className="font-display text-lg text-teal-900">{b.name}</div>
              <div className="text-xs text-muted-foreground">{b.town}, {b.region}</div>
              <p className="mt-2 text-sm text-teal-900 line-clamp-3">{b.description}</p>
            </div>
          </Link>
        ))}
        {items.length === 0 && (
          <div className="col-span-full text-sm text-muted-foreground text-center py-12" data-testid="biz-empty">
            No businesses match this filter yet.
          </div>
        )}
      </div>
    </div>
  );
}
